// extracted by mini-css-extract-plugin
module.exports = {"location-wrapper":"styles_location-wrapper__SJLv_"};